export const EeoQuestionsSettingsRoutes = [
    {
        "url": "/eeo/form/{formId:[0-9]*}",
        "name": "appLayout.harriSH.eeo-questions",
        "type": "frontend",
        "loginRequired": true,
        "component": "eeoQuestions",
        "params": {
            formId: {
                value: ""
            },
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: () => {
                    return import("@ngmodules/eeo-questions-settings/eeo-questions-settings.downgrade.module");
                }
            },
        ],
        "route_styles": {
            framework: "bootstrap_v4",
        },
    }
];
//# sourceMappingURL=eeo-questions-settings.routes.js.map